export let CrearDescargasComponent = {
    selector: 'crearDescargas',
    template: require('./crear-descargas.html'),
    controller: class {

        /*@ngInject*/
        constructor(DescargasService, $location, Upload, FILE_UPLOAD_URL, QR_UPLOAD_URL, ToasterService) {
            Object.assign(this, {DescargasService, $location, Upload, FILE_UPLOAD_URL, QR_UPLOAD_URL, ToasterService});
            this.nuevaDescarga = {nombre: '', tipo: 'pdf', link: '', qrUrl: ''};
            this.subiendoArchivo = false;
        }

        setTipo(tipo) {
            this.nuevaDescarga.tipo = tipo;
        }

        uploadFiles(file) {
            this.file = file;
        }

        uploadQr(file, err) {
            if (!err || err.length === 0)
                this.qrFile = file;
        }

        subirQr() {
            if (!this.qrFile) return Promise.resolve();
            return this.Upload.upload({
                    url: this.QR_UPLOAD_URL,
                    data: {
                        file: this.qrFile
                    }
                })
                .then((res) => {
                    this.nuevaDescarga.qrUrl = res.data.secure_url;
                });
        }

        crearDescarga(form) {
            if (form.$valid) {
                if (this.file) {
                    this.subiendoArchivo = true;
                    this.Upload.upload({
                            url: this.FILE_UPLOAD_URL,
                            data: {
                                file: this.file
                            }
                        })
                        .then((res) => {
                            this.nuevaDescarga.link = res.data.secure_url;
                            return this.subirQr();
                        })
                        .then(() => this.DescargasService.agregarDescarga(this.nuevaDescarga))
                        .then(() => {
                            this.ToasterService.popUp('success','Descarga', 'Se ha creado con éxito.');
                            this.$location.path('/');
                        })
                        .catch(() => {
                            this.subiendoArchivo = false;
                            this.ToasterService.popUp('error','Descarga', 'No se pudo crear la descarga.');
                        });
                } else {
                    this.subiendoArchivo = false;
                    this.ToasterService.popUp('info','Informacion', 'Seleccione un documento.');
                }
            } else {
                this.ToasterService.popUp('info','Informacion', 'El formulario esta incompleto o no es válido.');
            }
        }

    }
};



// WEBPACK FOOTER //
// ./client/app/descargas-route/crear/crear-descargas.component.js